<div
  class="bg-yellow-300 border border-yellow-400 text-slate-900 px-4 py-2 rounded relative z-50"
  role="alert"
>
  <strong class="font-bold uppercase">Attenzione sito Staging!</strong>
  <span class="block sm:inline">
    Le modifiche su questo sito non avranno effetto sui dati di produzione.
  </span>
</div>
